import React, { useEffect, useState } from "react";
import { assets } from "../../../Assets/assets";

const HomeHero = () => {
  const images = [
    assets.herobanner,
    assets.herobanner2,
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (i) => {
    setIndex(i);
  };

  return (
    <section data-aos="fade-up" className="w-full h-[80vh] relative overflow-hidden">

      <div className="absolute inset-0">
        {images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="hero"
            className={`absolute inset-0 w-full h-full object-cover object-left md:object-center transition-all duration-[1200ms] ease-in-out 
              ${index === i ? "opacity-100 translate-x-0 scale-100" : "opacity-0 translate-x-10 scale-105"}
            `}
          />
        ))}
      </div>

      <img
        className="absolute inset-0 w-full h-full opacity-0 object-cover pointer-events-none"
        src={assets.bannercover}
        alt="overlay"
      />

      <div className="absolute bottom-6 w-full flex justify-center gap-3">
        {images.map((_, i) => (
          <button
            key={i}
            onClick={() => goToSlide(i)}
            className={`w-4 h-4 rounded-full transition-all duration-300 border-2 border-white 
              ${index === i ? "bg-white scale-110 shadow-lg" : "bg-white/30 hover:bg-white/60"}
            `}
          ></button>
        ))}
      </div>
    </section>
  );
};

export default HomeHero;
